import React from 'react';
import { Button } from '~ui-kit/components/button/button';

export interface Tab {
  id: 'active' | 'notifications';
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  selectedTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export function Tabs({ tabs = [], selectedTab, onTabChange }: TabsProps) {
  return (
    <>
      {tabs.map((tab) => {
        const isSelected = selectedTab?.id === tab.id;
        return (
          <Button
            key={tab.id}
            shape="pill"
            appearance={isSelected ? 'filled' : 'outlined'}
            onClick={() => onTabChange(tab)}
          >
            {tab.label}
          </Button>
        );
      })}
    </>
  );
}
